<!--
 * @Author: andy_chen
 * @created: 2018-11-13 15:57:46
-->

<template>
    <div class="container">
        <list-item title="消息推送设置" :msg="apns ? '已开启' : '已关闭'" :hasBottomLine="true" @click="handleUpdateApns" class="top-split-line"></list-item>
        <template v-if="apns">
            <div class="group-title">互动通知</div>
            <div class="select-item border-bottom-line">
                <p>关注</p>
                <cat-switch class="switch-item" v-model="settings.focus" @change="handleChangeFocus"></cat-switch>
            </div>
            <div class="select-item border-bottom-line">
                <p>想去</p>
                <cat-switch class="switch-item" v-model="settings.wantToGo" @change="handleChangeFavor"></cat-switch>
            </div>
            <div class="select-item border-bottom-line">
                <p>评论</p>
                <cat-switch class="switch-item" v-model="settings.comment" @change="handleChangeComment"></cat-switch>
            </div>
            <div class="group-title">聊天消息通知</div>
            <div class="select-item border-bottom-line">
                <p>聊天</p>
                <cat-switch class="switch-item" v-model="settings.chat" @change="handleChangeChat"></cat-switch>
            </div>
        </template>
    </div>

</template>

<script>
import ListItem from "../components/ListItem";
import CatSwitch from "../components/CatSwitch";
import nativeApi from "../nativeApi/index.js";

export default {
    name: "PushSetting",
    components: {
        ListItem,
        CatSwitch
    },
    data() {
        return {
            apns: false,
            settings: {
                chat: false,
                comment: false,
                focus: false,
                wantToGo: false
            }
        };
    },

    mounted() {
        this.getConfig();
    },

    computed: {},

    methods: {
        handleChangeFocus() {
            this.saveConfig();
        },
        handleChangeFavor() {
            this.saveConfig();
        },
        handleChangeComment() {
            this.saveConfig();
        },
        handleChangeChat() {
            if (this.settings.chat) {
                this.saveConfig();
                return;
            }
            this.showConfirm("关闭后，你将收不到聊天信息").then(result => {
                if (result === 1) {
                    this.saveConfig();
                } else {
                    this.settings.chat = true;
                }
            });
        },

        handleUpdateApns() {
            if (!this.apns) {
                this.apns = true;
                this.saveConfig();
                return;
            }
            this.showConfirm("关闭后，你将不再收到任何消息通知").then(
                result => {
                    if (result === 1) {
                        this.apns = false;
                        this.saveConfig();
                    }
                }
            );
        },

        showConfirm(title) {
            return this.$messageBox({
                title: [title, "确认关闭吗？"],
                buttonList: ["取消", "关闭通知"]
            });
        },

        saveConfig() {
            let config = {
                apns: this.apns,
                settings: this.settings
            };
            this.$loading.open({ delay: 800 });
            nativeApi
                .setConfig(config)
                .then(res => {
                    if (res.state === 0) {
                        let config = res.data;
                        this.apns = config.apns;
                        this.settings = config.settings || {};
                    } else {
                        this.$toast.open({ msg: res.message });
                    }
                })
                .finally(() => {
                    this.$loading.close();
                });
        },

        getConfig() {
            this.$loading.open({ delay: 800 });
            nativeApi
                .getConfig()
                .then(res => {
                    if (res.state === 0) {
                        let config = res.data;
                        this.apns = config.apns;
                        this.settings = config.settings || {};
                    } else {
                        this.$toast.open({ msg: res.message });
                    }
                })
                .finally(() => {
                    this.$loading.close();
                });
        }
    }
};
</script>

<style scoped lang="scss">
@import "../style/function.scss";
@import "../style/config.scss";

input {
    background: #ffffff;
    box-sizing: border-box;
    width: 100%;
    outline: none;
    border: none;
    // /*去除系统默认的样式*/
    -webkit-appearance: none;
    // /* 点击高亮的颜色*/
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.container {
    background: $baseBackgroundColor;
}

.group-title {
    height: 0.6rem;
    display: flex;
    align-items: center;
    padding-left: 0.3rem;
    color: #999;
}
.select-item {
    height: 1.1rem;
    display: flex;
    align-items: center;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    background: #fff;
    position: relative;
    font-size: 0.28rem;
    justify-content: space-between;
}
</style>
